<template>
  <div class="content-container">
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item label="订单号">
        <el-input
          v-model="formInline.orderid"
          placeholder="请输入订单号"
        ></el-input>
      </el-form-item>
      <el-form-item label="用户名">
        <el-input
          v-model="formInline.username"
          placeholder="请输入用户名"
        ></el-input>
      </el-form-item>
      <el-form-item label="手机号">
        <el-input
          v-model="formInline.usermobile"
          placeholder="请输入用户手机号"
        ></el-input>
      </el-form-item>
      <el-form-item label="机器号">
        <el-input
          v-model="formInline.machineid"
          placeholder="请输入机器号"
        ></el-input>
      </el-form-item>
      <el-form-item label="退款状态">
        <el-select v-model="formInline.refundStatus" placeholder="请选择">
          <el-option
            v-for="(item, index) in REFUND_STATUS_ENUM"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="起止时间">
        <el-date-picker
          v-model="formInline.date"
          type="daterange"
          range-separator="~"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="onSubmit"
          >查询</el-button
        >
        <el-button
          type="primary"
          icon="el-icon-download"
          @click="handleDownload"
          >下载</el-button
        >

        <el-button type="success" icon="el-icon-refresh" @click="refresh"
          >刷新</el-button
        >
      </el-form-item>
    </el-form>
    <el-table :data="tableData">
      <el-table-column label="订单号" width="110">
        <template slot-scope="scope">
          <router-link
            class="link-div"
            tag="div"
            :to="{
              name: 'order',
              query: { orderid: scope.row.refundEntity.orderid }
            }"
            >{{ scope.row.refundEntity.orderid }}</router-link
          >
        </template>
      </el-table-column>
      <el-table-column prop="refundEntity.username" label="用户名" width="100">
      </el-table-column>

      <el-table-column
        prop="refundEntity.troubleid"
        label="关联报障"
        width="100"
      >
        <template slot-scope="scope">
          <router-link
            class="link-div"
            tag="div"
            :to="{
              name: 'fault',
              query: { troubleid: scope.row.refundEntity.troubleid }
            }"
            >{{ scope.row.refundEntity.troubleid }}</router-link
          >
        </template>
      </el-table-column>

      <el-table-column
        prop="refundEntity.usermobile"
        label="手机号"
        width="120"
      >
      </el-table-column>

      <el-table-column label="机器号" width="130">
        <template slot-scope="scope">
          {{ scope.row.refundEntity.machineid }}
          <el-button
            type="primary"
            plain
            size="mini"
            round
            @click="searchSame(scope.row.refundEntity.machineid)"
            >相关</el-button
          >
        </template>
      </el-table-column>

      <el-table-column prop="shopName" label="门店" width="120">
      </el-table-column>
      <el-table-column prop="refundEntity.reason" label="退款理由">
      </el-table-column>
      <el-table-column prop="refundEntity.refundAmount" label="退款金额">
      </el-table-column>
      <el-table-column prop="refundEntity.refundStatus" label="退款状态">
        <template slot-scope="scope">
          <el-tag
            type="info"
            effect="dark"
            v-if="scope.row.refundEntity.refundStatus == 0"
            >等待审核</el-tag
          >
          <el-tag
            type="success"
            effect="dark"
            v-else-if="scope.row.refundEntity.refundStatus == 10"
            >申请通过</el-tag
          ><el-tag
            color="#E7221B"
            effect="dark"
            v-else-if="scope.row.refundEntity.refundStatus == 20"
            >申请拒绝</el-tag
          ><el-tag
            type=""
            effect="dark"
            v-else-if="scope.row.refundEntity.refundStatus == 30"
            >已打款</el-tag
          ><el-tag
            type="danger"
            effect="dark"
            v-else-if="scope.row.refundEntity.refundStatus == 40"
            >打款异常</el-tag
          >
          <el-tag
            type="danger"
            effect="dark"
            v-else-if="scope.row.refundEntity.refundStatus == 50"
            >撤销申请</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column prop="refundEntity.refundOperator" label="操作人">
      </el-table-column>
      <el-table-column prop="refundEntity.remark" label="备注">
      </el-table-column>
      <el-table-column prop="refundEntity.denyReason" label="拒绝原因">
      </el-table-column>
      <el-table-column label="申请时间" width="160">
        <template slot-scope="scope">
          <div>{{ scope.row.refundEntity.createtime | formatDateTime }}</div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="260">
        <template slot-scope="scope">
          <!-- <el-button type="text" @click="buquan(scope.row.refundEntity)"
            >补券</el-button
          > -->
          <el-button
            type="text"
            @click="showUniqueCoupon(scope.row.refundEntity)"
            >补券</el-button
          >
          <el-button
            type="text"
            :loading="notifyMessageLoadingId === scope.row.refundEntity.id"
            @click="directToNotifyMessage(scope.row.refundEntity)"
            >报文</el-button
          >
          <el-button
            type="text"
            @click="pass(scope.row.refundEntity)"
            v-if="
              scope.row.refundEntity.refundStatus != 10 &&
                scope.row.refundEntity.refundStatus != 30 &&
                scope.row.refundEntity.refundStatus != 50
            "
            >通过</el-button
          >
          <el-button
            type="text"
            @click="deny(scope.row.refundEntity)"
            v-if="scope.row.refundEntity.refundStatus == 0"
            >驳回</el-button
          ><el-button type="text" @click="remark(scope.row.refundEntity)"
            >备注</el-button
          >
          <el-button
            type="text"
            @click="denyReason(scope.row.refundEntity)"
            v-if="
              scope.row.refundEntity.refundStatus == 0 ||
                scope.row.refundEntity.refundStatus == 20
            "
            >驳回理由</el-button
          >
          <!-- <el-badge :value="scope.row.unreadCommentsCount">
            <el-button
              type="primary"
              size="mini"
              @click="chat(scope.row.refundEntity)"
              >对话</el-button
            >
          </el-badge> -->
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page.sync="page.currentPage"
      :page-size="page.pageSize"
      layout="total, prev, pager, next"
      :total="page.total"
    >
    </el-pagination>
    <editDialog
      v-if="isDialogShow"
      @closeForm="closeForm"
      @onSubmit="onSubmit"
      :refund="refund"
    />

    <editDenyReasonDialog
      v-if="isDenyReasonDialogShow"
      @closeForm="closeForm"
      @onSubmit="onSubmit"
      :refund="refund"
    />

    <chatDialog
      v-if="isChatDialogShow"
      @closeForm="closeForm"
      :refund="refund"
    />

    <!-- <buquanDialog
      v-if="isBuquanDialogShow"
      @closeBuquanForm="closeBuquanForm"
      :refund="refund"
    /> -->

    <el-dialog
      :title="'用户'"
      :visible.sync="isUniqueDialogShow"
      width="40%"
      :close-on-click-modal="true"
      :close-on-press-escape="true"
    >
      <el-form
        :model="formInline"
        :inline="false"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="补券给" prop="usermobile">
          {{ formInline.uniqueCoupon.usermobile }}
        </el-form-item>
        <el-form-item label="金额：" prop="discountAmount">
          <el-col :span="8">
            <el-input-number
              v-model="formInline.uniqueCoupon.discountAmount"
              :min="1"
              label="请输入金额"
            ></el-input-number>
          </el-col>
        </el-form-item>
        <el-form-item label="截止时间" prop="expireDate">
          <el-col :span="8">
            <el-date-picker
              v-model="formInline.uniqueCoupon.expireDate"
              type="date"
              placeholder="请输入截止时间"
              style="width:100%;"
            ></el-date-picker
          ></el-col>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="bindUniqueCouponToUser"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import enumObject from "../../plugins/enum";
import editDialog from "./components/editDialog";
import editDenyReasonDialog from "./components/editDenyReasonDialog";
import chatDialog from "./components/chatDialog";
// import buquanDialog from "./components/buquanDialog";
import moment from "moment";

export default {
  components: {
    editDialog,
    editDenyReasonDialog,
    chatDialog
    // buquanDialog
  },
  data() {
    return {
      formInline: {
        orderid: "",
        username: "",
        usermobile: "",
        machineid: "",
        refundStatus: "",
        date: [moment().subtract(7, "days"), moment().add(1, "days")],

        uniqueCoupon: {
          usermobile: undefined,
          discountAmount: 0,
          expireDate: moment().add(30, "days")
        },
        refund: {}
      },
      tableData: [],
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      comment: null,
      isDialogShow: false,
      isDenyReasonDialogShow: false,
      isChatDialogShow: false,
      //isBuquanDialogShow: false,
      isUniqueDialogShow: false,
      notifyMessageLoadingId: null,
      REFUND_STATUS_ENUM: enumObject.REFUND_STATUS_ENUM
    };
  },
  mounted() {
    this.onSubmit();
  },
  methods: {
    redirectToTrouble(item) {
      console.log(item);
    },

    searchSame(machineid) {
      this.formInline.machineid = machineid;
      this.formInline.orderid = "";
      this.formInline.username = "";
      this.formInline.usermobile = "";
      this.formInline.date = "";

      this.onSubmit();
    },
    onSubmit() {
      let queryModel = {
        orderid: this.formInline.orderid,
        username: this.formInline.username,
        machineid: this.formInline.machineid,
        usermobile: this.formInline.usermobile,
        refundStatus: this.formInline.refundStatus,
        createtimeFrom: Array.isArray(this.formInline.date)
          ? this.$ToDateTimeString(this.formInline.date[0])
          : null,
        createtimeTo: Array.isArray(this.formInline.date)
          ? this.$ToDateTimeString(this.formInline.date[1])
          : null,
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize,
        orderField: "id",
        orderSequence: "DESC"
      };
      this.$axios(this.$urlMapping["查询退款"], {
        data: queryModel
      }).then(result => {
        console.log(result.data);
        this.tableData = result.data;

        this.tableData.forEach(x => {
          if (x.comments) {
            x.unreadCommentsCount = x.comments.filter(
              y => y.username !== "管理员" && y.hasRead == false
            ).length;
          }
        });

        console.log(this.tableData);
        this.page.total = result.totalCount;
        this.page.currentPage = result.pageNum;
      });
    },
    handleCurrentChange(currentPage) {
      this.page.currentPage = currentPage;
      this.onSubmit();
    },
    closeForm() {
      this.isDialogShow = false;
      this.isChatDialogShow = false;
      this.isDenyReasonDialogShow = false;
      //this.isBuquanDialogShow = false;
      this.isUniqueDialogShow = false;
      this.onSubmit();
    },

    //closeBuquanForm() {
    //  this.isBuquanDialogShow = false;
    //},

    remark(refund) {
      //console.log(refund);
      this.refund = refund;
      this.isDialogShow = true;
    },

    denyReason(refund) {
      //console.log(refund);
      this.refund = refund;
      this.isDenyReasonDialogShow = true;
    },
    // buquan(refund) {
    //   console.log("buquan", refund);
    //   this.refund = refund;
    //   this.isBuquanDialogShow = true;
    // },

    bindUniqueCouponToUser() {
      console.log("bindUniqueCouponToUser", this.formInline.uniqueCoupon);

      this.$axios(this.$urlMapping["分配独特优惠券"], {
        data: {
          ...this.formInline.uniqueCoupon
        }
        // eslint-disable-next-line no-unused-vars
      }).then(result => {
        this.$notifySuccess();
        this.onSubmit();
      });
    },

    showUniqueCoupon(refund) {
      // this.refund = refund;
      console.log(refund);
      console.log(refund.usermobile);
      this.formInline.uniqueCoupon.usermobile = refund.usermobile;
      this.isUniqueDialogShow = true;
    },
    async directToNotifyMessage(refund) {
      let notifyWindow = window.open("", "_blank");
      if (!notifyWindow) {
        this.$message.warning("浏览器阻止了新标签页，请允许弹出窗口后重试");
        return;
      }
      this.notifyMessageLoadingId = refund.id;
      try {
        let result = await Promise.all([
          this.$axios(this.$urlMapping["查询订单"], {
            data: {
              orderid: refund.orderid,
              pageNum: 1,
              pageSize: 1
            }
          }),
          this.$axios(this.$urlMapping["查询机器"], {
            data: {
              machineid: refund.machineid,
              pageNum: 1,
              pageSize: 1
            }
          })
        ]);
        let orderData = result[0].data && result[0].data[0];
        let machineData = result[1].data && result[1].data[0];
        let order = orderData && orderData.orderInfo;
        let machine = machineData && machineData.machineExtendModel;

        if (!order || !order.paidTime) {
          notifyWindow.close();
          this.$message.error("未查询到订单支付时间");
          return;
        }
        if (!machine || !machine.machineImei) {
          notifyWindow.close();
          this.$message.error("未查询到机器IMEI");
          return;
        }
        if (!refund.createtime) {
          notifyWindow.close();
          this.$message.error("未查询到退款申请时间");
          return;
        }

        let routeData = this.$router.resolve({
          name: "notifyMessage",
          query: {
            imei: machine.machineImei,
            from: this.$ToDateTimeString(moment(order.paidTime)),
            to: this.$ToDateTimeString(moment(refund.createtime))
          }
        });
        notifyWindow.location.href = routeData.href;
      } catch (e) {
        notifyWindow.close();
        throw e;
      } finally {
        this.notifyMessageLoadingId = null;
      }
    },
    chat(refund) {
      console.log(refund);
      this.refund = refund;
      this.isChatDialogShow = true;
    },
    pass(refund) {
      this.$confirm("是否确认通过审核?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let ids = [refund.id];
        let refundStatus = this.REFUND_STATUS_ENUM.filter(
          ele => ele.label == "申请通过"
        )[0].value;
        this.$axios(this.$urlMapping["退款审核"], {
          data: {
            ids: ids,
            refundStatus: refundStatus
          }
          // eslint-disable-next-line no-unused-vars
        }).then(result => {
          this.$notifySuccess();
          this.onSubmit();
        });
      });
    },
    deny(refund) {
      this.$confirm("是否确认拒绝申请?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let ids = [refund.id];
        let refundStatus = this.REFUND_STATUS_ENUM.filter(
          ele => ele.label == "申请拒绝"
        )[0].value;
        this.$axios(this.$urlMapping["退款审核"], {
          data: {
            ids: ids,
            refundStatus: refundStatus
          }
          // eslint-disable-next-line no-unused-vars
        }).then(result => {
          this.$notifySuccess();
          this.onSubmit();
        });
      });
    },
    handleDownload() {
      let queryModel = {
        orderid: this.formInline.orderid,
        username: this.formInline.username,
        machineid: this.formInline.machineid,
        usermobile: this.formInline.usermobile,
        refundStatus: this.formInline.refundStatus,
        createtimeFrom: Array.isArray(this.formInline.date)
          ? this.$ToDateTimeString(this.formInline.date[0])
          : null,
        createtimeTo: Array.isArray(this.formInline.date)
          ? this.$ToDateTimeString(this.formInline.date[1])
          : null,
        pageNum: 1,
        pageSize: 999999,
        orderField: "id",
        orderSequence: "DESC"
      };

      let t1 = moment(queryModel.createtimeFrom);
      let t2 = moment(queryModel.createtimeTo);
      let days = t2.diff(t1, "days");
      if (days < 0 || days > 92) {
        this.$notify.error({
          title: "错误",
          message: "时间跨度最多3个月"
        });

        return;
      }

      this.$download(this.$urlMapping["下载退款列表"], {
        data: queryModel
      }).then(result => {
        let fileName = "退款列表" + this.$ToDateTimeString(moment());
        this.downloadCSV(result.data, fileName);
      });
    },
    downloadCSV(data, fileName) {
      var blob = new Blob([data], {
        type: "application/octet-stream;charset=utf-8"
      });
      var downloadElement = document.createElement("a");
      var href = window.URL.createObjectURL(blob); // 创建下载的链接
      downloadElement.href = href;
      downloadElement.download =
        typeof fileName !== "undefined"
          ? fileName + ".csv"
          : "退款列表" + this.$ToDateTimeString(moment()) + ".csv"; // 下载后文件名
      document.body.appendChild(downloadElement);
      downloadElement.click(); // 点击下载
      document.body.removeChild(downloadElement); // 下载完成移除元素
      window.URL.revokeObjectURL(href); // 释放掉blob对象
    },
    refresh() {
      this.formInline = {
        orderid: "",
        username: "",
        usermobile: "",
        machineid: "",
        refundStatus: "",
        date: [moment().subtract(7, "days"), moment().add(1, "days")]
      };

      this.onSubmit();
    }
  }
};
</script>

<style lang="less" scoped>
.badge {
  cursor: pointer;
  margin-left: 0px;
}

/deep/.el-badge__content.is-fixed {
  position: absolute;
  top: 5px;
  right: 10px;
  -webkit-transform: translateY(-50%) translateX(100%);
  transform: translateY(-50%) translateX(100%);
}
/deep/.el-badge__content {
  background-color: #f56c6c;
  border-radius: 10px;
  color: #fff;
  display: inline-block;
  font-size: 4px;
  height: 14px;
  line-height: 14px;
  padding: 0 4px;
  text-align: center;
  white-space: nowrap;
  border: 1px solid #fff;
}
</style>
